import React from 'react';

const Trayectoria = () => {
  return (
    <section className="py-16 sm:py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#001F3F] mb-6 sm:mb-8 text-center lg:text-left">
            Trayectoria del Estudio
          </h2>

          <div className="grid lg:grid-cols-2 gap-0 items-stretch rounded-2xl overflow-hidden shadow-lg">
            {/* Image */}
            <div className="relative h-full min-h-[400px]">
            <img 
              src="/images/5.jpeg" 
              alt="Equipo de profesionales SP Asociados" 
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content */}
          <div className="bg-[#0A0B2E] text-white p-8 sm:p-12 flex flex-col justify-center relative overflow-hidden">
            {/* Background Vector */}
            <img 
              src="/svg/Union.svg" 
              alt="" 
              className="absolute bottom-0 right-0 w-48 sm:w-64 opacity-20"
            />
            
            <div className="relative z-10">
              <div className="mb-8">
                <div className="text-6xl sm:text-7xl font-bold mb-2">+17</div>
                <div className="text-xl sm:text-2xl font-semibold">Años de experiencia</div>
              </div>

              <div className="space-y-4 text-white/90 leading-relaxed">
                <p>
                  SP nació con la convicción y el entusiasmo de dos contadoras que trabajaban cada una con sus especialidades, y se complementaban para realizar trabajos complejos que se convertían en reales desafíos. En equipo lograban exitosos resultados!
                </p>
                <p>
                  De esta forma, decidimos arrancar juntas en nuestro proyecto, y así hemos llegado después de 17 años, con una cartera de clientes que depositaron su confianza en el trabajo que realizamos con el plantel de colaboradores que aportaron su enriquecida experiencia formando así, este grupo humano que se destaca por la calidad, el compromiso y la atención personalizada para brindar la mejor experiencia a los clientes.
                </p>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Trayectoria;
